var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.editName,{key:_vm.key,ref:"addEdit",tag:"component",staticClass:"xrk-project-container",on:{"resetRuleForm":_vm.resetRuleForm}})}
var staticRenderFns = []

export { render, staticRenderFns }